import { GeneralTeacherComponent } from "../../../General/gt.component";
import { InteractiveGraph } from "graph-interactive/dist/lib/interactive/interactiveGraph";
import { Subject } from "rxjs";
import { GraphServiceJson, NameVertex } from "graph-interactive";

export abstract class TeacherGraphExerciseComponent extends GeneralTeacherComponent {

    protected graphSubject: Subject<InteractiveGraph> = new Subject<InteractiveGraph>();
    protected graph: InteractiveGraph = null;

    ngAfterViewInit(): void {
        //Reset names
        NameVertex.resetNames();
        this.graph = this.initGraph();
        this.graphSubject.next(this.graph);

        if (this.configuration != null && this.configuration !== undefined) {
            if (this.configuration.typespecifics) {
                GraphServiceJson.importGraph(this.graph, this.configuration);
            }
        }
    }

    exportMinimumPath(minPath: number, definition: any) {
        if (definition.condition == undefined) {
            definition.condition = {};
        }
        definition.condition.minPath = minPath;
    }

    exportPathLength(pathLength: number, definition: any) {
        if (definition.condition == undefined) {
            definition.condition = {};
        }
        definition.condition.pathLength = pathLength;
    }

    importMinimumPath(): number {
        let result = -1;
        if (this.configuration == undefined || this.configuration == null)
            return result;
        if (this.configuration.condition.minPath != undefined) {
            result = Number(this.configuration.condition.minPath);
        }
        return result;
    }

    importPathLength(): number {
        let result = -1;
        if (this.configuration == undefined || this.configuration == null)
            return result;
        if (this.configuration.condition.pathLength != undefined) {
            result = Number(this.configuration.condition.pathLength);
        }
        return result;
    }


    abstract initGraph(): InteractiveGraph;

}